/**
 * Call log `call_date` may arrive as `YYYY-MM-DD` or ISO datetime.
 * `String(d).split("T")[0]` keeps the UTC calendar day, which can differ from the day the user
 * sees in the table when the API uses Z-shifted instants (e.g. IST midnight as prior UTC date).
 */

export function toCallLogCalendarDateKey(value) {
  if (value == null || value === "") return "";
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  // Accept backend/localized day-first dates explicitly: DD-MM-YYYY or DD/MM/YYYY.
  const dmy = s.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
  if (dmy) {
    const dd = Number(dmy[1]);
    const mm = Number(dmy[2]);
    const yyyy = Number(dmy[3]);
    if (yyyy >= 1900 && mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31) {
      return `${yyyy}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
    }
  }
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) {
    const pre = s.match(/^(\d{4}-\d{2}-\d{2})/);
    return pre ? pre[1] : "";
  }
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function formatCallDateDisplay(value) {
  const key = toCallLogCalendarDateKey(value);
  if (!key) return "—";
  const [y, m, d] = key.split("-").map(Number);
  if (!y || !m || !d) return key;
  const dt = new Date(y, m - 1, d);
  return dt.toLocaleDateString(undefined, { year: "numeric", month: "numeric", day: "numeric" });
}

/** Match MySQL TIME equality: HH:MM:SS */
export function padTimeForApi(t) {
  const s = String(t ?? "").trim();
  if (!s) return "";
  const m = s.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (!m) return s;
  const h = String(m[1]).padStart(2, "0");
  const min = String(m[2]).padStart(2, "0");
  const sec = String(m[3] ?? "00").padStart(2, "0");
  return `${h}:${min}:${sec}`;
}
